import GDPRPopup from './GDPRPopup'

export default GDPRPopup
